import { useState } from 'react'
import { useVenues } from '@/hooks/useVenues'
import { VenuesTable, type VenueFilter } from '@/components/features/venues/VenuesTable'

export function Venues() {
  const { data: venues, isLoading, error } = useVenues()
  const [filter, setFilter] = useState<VenueFilter>('all')

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-muted-foreground">Loading venues...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6">
        <h2 className="font-semibold text-destructive">Failed to load venues</h2>
        <p className="mt-1 text-sm text-muted-foreground">{error.message}</p>
      </div>
    )
  }

  if (!venues || venues.length === 0) {
    return (
      <div className="space-y-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Venues</h1>
          <p className="text-muted-foreground mt-2">No venues found.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Venues</h1>
        <p className="text-muted-foreground mt-2">
          Browse and manage venue records. Click a row to view details.
        </p>
      </div>
      <VenuesTable venues={venues} filter={filter} onFilterChange={setFilter} />
    </div>
  )
}
